import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { Message, Button } from 'semantic-ui-react';

const STORAGE_KEY = 'no-mentions-banner-dismissed';

export default class CampaignNoMentionsBanner extends Component {
  constructor(props) {
    super(props);
    const { campaign, dyzioStorage } = props;
    const campaignId = _.get(campaign, 'id');
    const stored = dyzioStorage.getCampaignSettings({ campaignId, key: STORAGE_KEY });
    this.state = { dismissed: stored === true };
  }

  onDismiss = () => {
    const { campaign, dyzioStorage } = this.props;
    const campaignId = _.get(campaign, 'id');
    dyzioStorage.updateCampaignSettings({ campaignId, key: STORAGE_KEY, value: true });
    this.setState({ dismissed: true });
  };

  render() {
    const { campaign } = this.props;
    if (this.state.dismissed) return null;
    const hashtags = _.get(campaign, 'hashtags', '');
    const hasMention = _.some(_.split(hashtags, ','), t => _.startsWith(_.trim(t), '@'));
    if (hasMention) return null;
    return (
      <Message size="tiny" warning icon="warning circle">
        <Message.Content style={{ display: 'flex', alignItems: 'center', gap: '1em' }}>
          <div style={{ flex: 1 }}>
            <Message.Header>No @mention tracked</Message.Header>
            <p>This campaign has no @mentions.</p>
          </div>
          <Button size="tiny" onClick={this.onDismiss}>Dismiss</Button>
        </Message.Content>
      </Message>
    );
  }
}

CampaignNoMentionsBanner.propTypes = {
  campaign: PropTypes.object.isRequired,
  dyzioStorage: PropTypes.object.isRequired,
};



/** WEBPACK FOOTER **
 ** ./src/components/campaign-no-mentions-banner/index.js
 **/